<style scoped>
.current-name {
  color: #1976d2 !important;
}
</style>
<template>
  <v-form ref="form" v-model="valid">
    <v-row>
      <v-col class="pb-0">
        <div>
          <anchor-text-field
            id="permission-form-name-input"
            required
            label="Name"
            :disabled="editing"
            v-model="model.name"
            :rules="rules.name"
          />
        </div>
        <div>
          <anchor-text-field
            id="permission-form-description-input"
            required
            label="Description"
            v-model="model.description"
            :rules="rules.description"
          />
        </div>
        <div>
          <v-select
            dense
            outlined
            id="group-domain-select"
            label="Select a domain"
            :items="allowedDomains"
            item-value="_id"
            item-text="name"
            :disabled="editing"
            v-model="model.domain"
            :rules="rules.domain"
          />
        </div>
      </v-col>
    </v-row>
    <div class="d-flex mb-4">
      <v-spacer />
      <v-btn id="permission-form-cancel-btn" @click="() => $emit('cancel')">
        Cancel
      </v-btn>
      <v-btn
        id="permission-form-save-btn"
        :disabled="!valid || error"
        :loading="loading"
        color="primary"
        class="ml-3"
        @click="submit"
      >
        Save
      </v-btn>
    </div>
  </v-form>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import PERMISSION_MODEL from './resources/model';
import FORM_RULES from './resources/rules';

export default {
  name: 'AdminPermissionsForm',
  data: () => ({
    model: PERMISSION_MODEL,
    rules: FORM_RULES,
    currentName: '',
    valid: false,
    loading: false,
    error: null,
  }),
  computed: {
    allowedDomains() {
      return this.$store.getters.role?.domains || [];
    },
    editing: vm => vm.model.id !== undefined,
  },
  methods: {
    setModel(permission) {
      this.$refs.form.reset();
      if (permission) {
        const mdl = {};
        Object.keys(PERMISSION_MODEL).forEach(key => {
          mdl[key] = permission[key];
        });
        mdl.id = permission._id;
        this.model = mdl;
      } else {
        const model = {};
        this.model = Object.assign(model, PERMISSION_MODEL);
      }
    },
    createPermission() {
      this.loading = true;
      const method = this.model.id ? 'put' : 'post';
      const url = this.model.id ? `/v1/permissions/${this.model.id}` : '/v1/permissions';
      delete this.model.id;
      this.$requests[method](url, this.model)
        .then(() => {
          this.$toast.success('Permission successfully saved!', { timeout: 3000 });
          this.$emit('success');
        })
        .catch(err => {
          this.$toast.error(err.response.data?.message || 'Unable to save permission...', { timeout: 3000 });
        })
        .then(() => {
          this.loading = false;
        });
    },
    submit() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.createPermission();
    },
  },
  mounted() {
    this.$refs.form.reset();
    const model = {};
    this.model = Object.assign(model, PERMISSION_MODEL);
  },
};
</script>
